import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { useSections, isSectionOn } from "@/hooks/useSections";
import { CalendarDays } from "lucide-react";
import SafeHtml from "@/components/SafeHtml";

export default function News() {
  const { t, lang, pick } = useI18n();
  const sections = useSections();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/news").then((r) => setItems(r.data)); }, []);

  if (!isSectionOn(sections, "news")) return (
    <div className="container-x py-24 text-navy/60" data-testid="news-off">
      {lang === "ar" ? "هذا القسم غير متاح حالياً." : "This section is currently unavailable."}
    </div>
  );

  return (
    <div data-testid="news-page">
      <section className="bg-navy text-cream py-24">
        <div className="container-x">
          <span className="eyebrow">{t("nav.news")}</span>
          <h1 className="mt-4 text-4xl md:text-6xl">
            {lang === "ar" ? "آخر الأخبار" : "Latest News"}
          </h1>
          <span className="divider-gold" />
        </div>
      </section>

      <section className="container-x py-16 space-y-6">
        {items.map((n) => (
          <article key={n.id} data-testid={`news-${n.id}`} className="card-elev overflow-hidden">
            {(n.image_url || n.cover_image) && (
              <div className="aspect-[21/9] overflow-hidden">
                <img src={n.image_url || n.cover_image} alt="" className="w-full h-full object-cover" data-testid={`news-image-${n.id}`} />
              </div>
            )}
            <div className="p-8">
              <div className="text-xs text-navy/60 flex items-center gap-2">
                <CalendarDays size={14} className="text-gold" />
                {new Date(n.created_at).toLocaleDateString(lang === "ar" ? "ar" : "en")}
              </div>
              <h2 className="mt-3 text-2xl text-navy">{pick(n, "title")}</h2>
              <SafeHtml className="mt-3 prose text-navy/80" html={pick(n, "body")} />
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
